<template>
    <div class="msg-list">
        <!-- <mt-navbar v-model="selected" :fixed="true">
            <mt-tab-item @click.native="navbarItemClick" id="0">我邀请的代理人</mt-tab-item>
            <mt-tab-item @click.native="navbarItemClick" id="1">我邀请的老师</mt-tab-item>
        </mt-navbar> -->
        <mt-tab-container v-model="selected" v-infinite-scroll="loadMoreInfo"
                            infinite-scroll-disabled="aloading"
                            infinite-scroll-distance="10">
            <mt-tab-container-item id="0">
                <div class="list-table" v-for="(item) in agent_msgList" :key="item.ID">
                    <div class="table-left" @click="go_detailInfo(item)">
                        <img style="width: 50px;height: 50px;" src="../../assets/man_img.png" alt="">
                    </div>
                    <div class="table-right" @click="go_detailInfo(item)">
                        <div class="right-info2">
                            <div>{{item.TeacherName}}</div>
                            <div style="text-align: right">{{item.TeacherPhone}}</div>
                            <!-- <div style="text-align: right">{{item.Phone}}</div> -->
                        </div>
                        <div class="right-area">{{item.Content}}</div>
                        <div class="right-time">
                            <div>所属学校：</div>
                            <div>{{item.schoolname}}</div>
                        </div>
                        <div class="right-timestate">
                            <div class="time">
                                <div>申请时间：</div>
                                <div>{{item.datas}}</div>
                            </div>
                            <span class="state" :style="{'color': item.IsRead =='False'?'#c3524c':'#72c34c'}">{{item.IsRead =='False'?'未读':'已读'}}</span>
                            
                            <span v-if="item.IsFeedback==1" class="state" :style="{'color': '#72c34c'}">
                                已响应
                            </span>
                            <span v-else-if="item.IsFeedback==2" class="state" :style="{'color': '#c3524c'}">
                                未响应
                            </span>
                        </div>
                    </div>
                </div>
                <h3 style="font-size:16px;margin-top:80px" v-if="agent_msgList.length<=0">暂无申请设备信息</h3>
                <!-- <p v-if="show_line&&agent_msgList.length!=0" class="data-base-line">到底了</p> -->
            </mt-tab-container-item>
        </mt-tab-container>
    </div>
</template>
<script>
export default {
    data() {
        return{
            selected: '0',
            // 我的代理商
            agent_msgList: [],
            aloading: false,
            reqData: {
                PageIndex: 0,
                PageSize: 15
            },
            show_line: false
        }
    },
    methods: {
        navbarItemClick() {
            let _this = this;
            _this.$indicator.open('加载中...');
            _this.aloading = true;
            _this.show_line = false;
            _this.reqData.PageIndex = 1;
            if(_this.selected == 0) {
                _this.abp.api.AgentRetrieveAgent(_this.reqData)
                    .then((res)=> {
                        _this.$indicator.close();
                        if(res.status == 200) {
                            if(res.data.IsSuccess) {
                                if(res.data.Data.length < _this.reqData.PageSize) {
                                    _this.show_line = true;
                                    _this.aloading = true;
                                }else{
                                    this.aloading = false;
                                }
                                res.data.Data.forEach(ele => {
                                    ele.datas = _this.$moment(ele.JoinDate).calendar();
                                })
                                _this.my_teacher = [];
                                _this.my_agent = res.data.Data;
                            }else{
                                _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                            }
                        }
                    })
                    .catch((error)=>{
                        _this.$indicator.close();
                        try {
                            switch(error.status) {
                                case 401:
                                _this.abp.api.reqSuccess(_this,'您没有权限！')
                            }
                        } catch (txt) {
                            console.log(txt);
                        }
                    })
            }else{
                _this.abp.api.AgentReadTeacher(_this.reqData)
                    .then((res)=> {
                        _this.$indicator.close();
                        if(res.status == 200) {
                            if(res.data.IsSuccess) {
                                if(res.data.Data.length < _this.reqData.PageSize) {
                                    _this.show_line = true;
                                    _this.aloading = true;
                                }else{
                                    this.aloading = false;
                                }
                                res.data.Data.forEach(ele => {
                                    if(ele.MouseID) {
                                        ele.boolState = false;
                                        if(ele.State == 0) {
                                            ele.userState = '审核中';
                                        }else if(ele.State == 1){
                                            ele.boolState = true;
                                            ele.userState = '邀请成功';
                                        }else{
                                            ele.userState = '邀请失败';
                                        }
                                    }else{
                                        ele.boolState = false;
                                        ele.userState = '未绑定鼠标码';
                                    }
                                    ele.datas = _this.$moment(ele.UsedDate).calendar();
                                })
                                _this.my_agent = [];
                                _this.my_teacher = res.data.Data;
                            }else{
                                _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                            }
                        }
                    })
                    .catch((error)=>{
                        _this.$indicator.close();
                        try {
                            switch(error.status) {
                                case 401:
                                _this.abp.api.reqSuccess(_this,'您没有权限！')
                            }
                        } catch (txt) {
                            console.log(txt);
                        }
                    })
            }
        },
        loadMoreInfo() {
            let _this = this;
            _this.$indicator.open('加载中...');
            _this.aloading = true;
            // _this.reqData.PageIndex = (_this.reqData.PageIndex+1);
            if(_this.selected == 0) {
                _this.abp.api.TeacherNeedsNotifyList()
                    .then((res)=> {
                        _this.$indicator.close();
                        if(res.status == 200) {
                            if(res.data.IsSuccess) {
                                _this.show_line = true;
                                _this.aloading = true;
                                console.log(res.data.Data.NeedList);
                                res.data.Data.NeedList.forEach(ele => {
                                    ele.data = JSON.parse(ele.Data);
                                    ele.IsFeedback=0;
                                    ele.data.AgentList.forEach(agent => {
                                        if(ele.AgentID===agent.AgentID)
                                        {
                                            ele.IsFeedback=  agent.IsFeedback;
                                        }                                      
                                    });
                                    ele.datas = _this.$moment(ele.CreateDate).calendar();
                                    ele.schoolname = ele.data.SchoolName;
                                    //ele.Phone = ele.Content.match('[0-9]{11}')[0];
                                })
                                // _this.agent_msgList = _this.agent_msgList.concat(res.data.Data);
                                _this.agent_msgList = res.data.Data.NeedList;
                            }else{
                                _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                            }
                        }
                    })
                    .catch((error)=>{
                        _this.$indicator.close();
                        try {
                            switch(error.status) {
                                case 401:
                                _this.abp.api.reqSuccess(_this,'您没有权限！')
                            }
                        } catch (txt) {
                            console.log(txt);
                        }
                    })
            }else{
                
            }
        },
        // 进入消息详情页
        go_detailInfo(e) {
            var data=JSON.parse(e.Data);
            this.$router.push({
                name: 'agentApplymouse',
                params: {
                    notifyID: e.NotifyID,
                    content:e.Content,
                    SchoolName:data.SchoolName,
                    TeacherName:e.TeacherName,
                    TeacherPhone:e.TeacherPhone,
                    IsFeedback:e.IsFeedback
                }
            })
        }
    },
    mounted() {
        let _this = this;
        _this.agent_msgList=[];
    }
}
</script>
<style scoped>
    .msg-list .mint-navbar.is-fixed {
        top: 0;
        left: 5px;
        right: 5px;
        overflow: hidden;
    }
    .msg-list .mint-tab-container {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: auto;
        top: 0px;
        /* top: 50px; */
        background-color: #eee;
    }
    .msg-list .mint-navbar {
        cursor: pointer;
    }
    .msg-list .mint-navbar>a:hover {
        background-color: #c2dcf0;
        color: #fff;
    }
    .msg-list .mint-navbar .is-selected .mint-tab-item-label {
        font-size: 14px;
        font-weight: 800;
    }
    .msg-list .mint-tab-container-item>h3 {
        margin-top: 50px;
        text-align: center;
    }
    .mint-navbar .mint-tab-item.is-selected {
        color: #000;
        margin-bottom: 0px;
        border-bottom: 2px solid #26a2ff;
    }
    .msg-list .mint-navbar>a:hover {
        color: #000;
        background-color: #fff;
    }
    .msg-list table{
        table-layout: fixed;
        word-break: break-all;
        word-wrap: break-word;
    }
    .msg-list .list-table {
        background-color: #fff;
        margin: 10px 5px 0;
        padding: 5px;
        border-radius: 5px;
        display: flex;
        align-items: center;
    }
    .msg-list .list-table>.table-left {
        width: 50px;
        height: 50px;
        margin: 10px;
    }
    .msg-list .list-table>.table-right {
        flex: 1;
    }
    .msg-list .list-table>.table-right>.right-info {
        display: flex;
        align-items: center;
        padding: 10px 0;
    }
    .msg-list .list-table>.table-right>.right-info2 {
        display: flex;
        align-items: center;
        padding: 10px 0;
    }
    .msg-list .list-table>.table-right>.right-info2>div {
        flex: 1;
    }
    .msg-list .list-table>.table-right>.right-info>div:first-child {
        width: 65px;
    }
    .msg-list .list-table>.table-right>.right-info>div:last-child {
        width: 100px;
    }
    .msg-list .list-table>.table-right>.right-area,
    .msg-list .list-table>.table-right>.right-time,
    .msg-list .list-table>.table-right>.right-timestate {
        display: flex;
        font-size: 14px;
        color: #555;
        padding: 5px 0;
        align-items: center;
        background-color: #fafafa;
    }
    .msg-list .list-table>.table-right>.right-timestate>.time {
        flex: 2;
        display: flex;
    }
    .msg-list .list-table>.table-right>.right-timestate>.state {
        padding-right: 10px;
        display: flex;
        font-size: 12px;
        justify-content: flex-end;
    }
    .msg-list .list-table>.table-right>.right-time {
        align-items: center;
    }
    
    .msg-list .list-table>.table-right>.right-area>div:last-child,
    .msg-list .list-table>.table-right>.right-time>div:last-child,
    .msg-list .list-table>.table-right>.right-timestate>.time>div:last-child  {
        flex: 1;
    }
    .msg-list .list-table>.table-right>.right-bot {
        display: flex;
        align-items: center;
        padding: 10px 0;
    }
    .msg-list .list-table>.table-right>.right-bot>div {
        flex: 1;
    }
    .msg-list .list-table>.table-right>.right-bot>div:last-child {
        text-align: right;
        align-items: center;
    }
</style>
